export default class Nav {

    static init() {
        window.addEventListener('scroll', function () {
            const navTop = document.querySelector('#nav-top');
            const navMenu = document.querySelector('#nav-menu');
            if (window.scrollY > (navTop.offsetTop + navTop.offsetHeight)) {
                if (! navMenu.classList.contains('fixed-nav')) {
                    navMenu.classList.add('fixed-nav');
                    navMenu.classList.add('shadow');
                }
            } else {
                navMenu.classList.remove('fixed-nav');
                navMenu.classList.remove('shadow');
            }
        });

        const navbarToggler = document.querySelector('.navbar-toggler');
        navbarToggler.addEventListener('click', function () {
            setTimeout(() => {
                if (!navbarToggler.classList.contains('collapsed')) {
                    document.querySelector('#front').classList.add('overflow-hidden');
                } else {
                    document.querySelector('#front').classList.remove('overflow-hidden');
                }
            }, 500);
        });

    }
}
